require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./basic-dogs-app-setup.json") })
        }
      }, "path---basic-dogs-app-setup");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---basic-dogs-app-setup!./.cache/json/basic-dogs-app-setup.json
// module id = 369
// module chunks = 231608221292675